define('router',['require','exports','module','jquery','base/router','base/region','underscore','modules/editor/index','modules/page_listing/index','modules/domain_listing/index','modules/lp_info/index','modules/page_generator/index','modules/lp_integration/index','modules/templates/index','modules/lp_leads/index','modules/stats/index'],function (require, exports, module) {
  'use strict';

  //require("bootstrap");
  var $ = require('jquery'),
    Router = require('base/router'),
    Region = require('base/region'),
    _ = require('underscore');

  var editorModule = require('modules/editor/index');

  function setBodyClassesFor(view) {
    $('body').attr('class', view.bodyClasses.join(' '));
  }

  var moduleManager = new Region({ $el: $('body') });

  module.exports = Router.extend({
    initialize: function () {
      require('modules/page_listing/index')(moduleManager);
      require('modules/domain_listing/index')(moduleManager);
      require('modules/lp_info/index')(moduleManager);
      require('modules/page_generator/index')(moduleManager);
      require('modules/lp_integration/index')(moduleManager);
      require('modules/templates/index')(moduleManager);
      require('modules/lp_leads/index')(moduleManager);
      require('modules/stats/index')(moduleManager);
    },

    routes: {
      'editor/:pageId': 'editor',
      'editor/:pageId/variants/:variantId': 'editor',
    },

    editor: function (pageId, variantId) {
      var view = editorModule({
        pageId: pageId,
        variantId: variantId,
      });
      moduleManager.show(view);
      setBodyClassesFor(view);
    },
  });
});

